import { gql } from "@apollo/client";

export const SEND_DOCUMENT_REJECTION_EMAIL = gql`
  mutation sendDocumentRejectionEmail($input: DocumentRejectionInput!) {
    documentHandler {
      sendDocumentRejectionEmail(input: $input) {
        success
      }
    }
  }
`;
